import React from "react";
import loading from "../../assets/images/loading.gif";

const Loading = ({ sizeDigit = 1, className = "", style = {}, src, isArr = true }) => {
    const loadingGif = src ?? loading;

    return (
        isArr ? Array.from({ length: sizeDigit }, (_, i) => (
            <img
                key={i}
                alt="Loading..."
                style={style}
                className={className}
                src={loadingGif}
            />
        ))
            : <img
                alt="Loading..."
                style={style}
                className={className}
                src={loadingGif}
            />
    );
};

export default Loading;
